import React, { useState } from "react";
import DailyBusinessReportTable from "./Components/DailyBusinessReportTable";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";

const formatDate = (date) => {
  if (!date) return "";
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const DailyBusinessReport = () => {
  const today = new Date();
  const todayStr = formatDate(today);

  const [filters, setFilters] = useState({
    checkin_date: todayStr,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const pickerValue = filters.checkin_date
    ? new Date(`${filters.checkin_date}T00:00:00`)
    : today;

  return (
    <PageBody
      card={true}
      headerchildren={
        <div className="d-flex justify-content-between align-items-center flex-wrap gap-3 w-100">
          <div>
            <HeadingOne>Daily Bill Report</HeadingOne>
            <p className="text-muted small mb-0">
              Check-in date wise booking breakdown with room charges, parking, and tax split.
            </p>
          </div>
        </div>
      }
    >
      <div className="col-12">
        <DailyBusinessReportTable
          filters={filters}
          date={{
            key: "checkin-date-picker",
            field: {
              name: "checkin_date",
              required: false,
              fieldSize: "p-0",
              placeholder: "Select Check-In Date",
              lableHide: true,
            },
            value: pickerValue,
            handleChange: handleChange,
            error: "",
            selectMode: "single",
          }}
        />
      </div>
    </PageBody>
  );
};

export default DailyBusinessReport;
